document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.embla');

  carousels.forEach(function (wrapperNode) {
    const viewportNode = wrapperNode.querySelector('.embla__viewport');
    const prevButtonNode = wrapperNode.querySelector('.embla__prev');
    const nextButtonNode = wrapperNode.querySelector('.embla__next');

    if (!viewportNode || typeof EmblaCarousel === 'undefined') return;

    const emblaApi = EmblaCarousel(viewportNode, { loop: false });

    if (prevButtonNode) {
      prevButtonNode.addEventListener('click', function () {
        emblaApi.scrollPrev();
      });
    }

    if (nextButtonNode) {
      nextButtonNode.addEventListener('click', function () {
        emblaApi.scrollNext();
      });
    }
  });
});